import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Tab, Tabs } from "@mui/material";
import SwitchToggle from "../../components/SwitchToggle";

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function CustomTabPanel({ children, value, index, ...other }: TabPanelProps) {
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <>{children}</>}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

const ViewWorkout = () => {
    const navigate = useNavigate();
    const [valueTabs, setValueTabs] = useState(0);

    const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
        setValueTabs(newValue);
    };

    return (
        <>
            <div className="main_title">
                <h1>Workout Details</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
                    <button onClick={() => navigate("/manage-workout")}>Manage Workouts</button>{" "}
                    - View Workout
                </p>
            </div>

            <div className="table_header">
                <Box className="custom_tabs1" sx={{ width: "100%" }}>
                    <Tabs
                        value={valueTabs}
                        onChange={handleChangeTabs}
                        className="custom_tabs_links"
                    >
                        <Tab label="Workout Info" {...a11yProps(0)} />
                        <Tab label="Media & Description" {...a11yProps(1)} />
                    </Tabs>
                </Box>
            </div>

            {/* Workout Info */}
            <CustomTabPanel value={valueTabs} index={0}>
                <div className="cards view_page">
                    <div className="table_header">
                        <h2>Workout Info</h2>
                    </div>

                    <div className="gap_p">
                        {/* Thumbnail */}
                        <div className="vew_img w_25">
                            <h6>Thumbnail</h6>
                            <figure>
                                <img src="/static/images/workout1.webp"  alt="Workout" />
                            </figure>
                        </div>

                        {/* Basic Workout Info */}
                        <div className="w_100">
                            <div className="gap_p">
                                <div className="w_33">
                                    <h6>Title</h6>
                                    <p>Full Body HIIT</p>
                                </div>
                                <div className="w_33">
                                    <h6>Duration</h6>
                                    <p>30 min</p>
                                </div>
                                <div className="w_33">
                                    <h6>Difficulty Level</h6>
                                    <p>Intermediate</p>
                                </div>
                                <div className="w_33">
                                    <h6>Muscle Group</h6>
                                    <p>Full Body</p>
                                </div>
                                <div className="w_33">
                                    <h6>Equipment</h6>
                                    <p>Dumbbells</p>
                                </div>
                                <div className="w_33">
                                    <h6>Status</h6>
                                    <SwitchToggle />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </CustomTabPanel>

            {/* Media & Description */}
            <CustomTabPanel value={valueTabs} index={1}>
                <div className="cards view_page">
                    <div className="table_header">
                        <h2>Media & Description</h2>
                    </div>

                    <div className="gap_p">
                        {/* Category */}
                        <div className="w_50">
                            <h6>Category</h6>
                            <p>HIIT</p>
                        </div>
                        <div className="w_50">
                            <h6>Sub-category</h6>
                            <p>Strength & Cardio</p>
                        </div>

                        {/* Description */}
                        <div className="w_100 mt_20">
                            <h6>Description</h6>
                            <p>
                                This is a 30-minute full body HIIT workout designed to improve
                                strength and stamina. Suitable for intermediate users.
                            </p>
                        </div>

                        {/* Media */}
                        <div className="w_50">
                            <h6>Workout Video</h6>
                            <video controls width="100%">
                                <source src="/static/videos/workout_demo.mp4" type="video/mp4" />
                                Your browser does not support the video tag.
                            </video>
                        </div>

                        {/* Timer Mode Example */}
                        <div className="w_50">
                            <h6>Timer Mode</h6>
                            <p>Start: 00:00, Rest: 00:30, Next Exercise: 01:00</p>
                        </div>
                    </div>
                </div>
            </CustomTabPanel>
        </>
    );
};

export default ViewWorkout;
